import React from 'react';

import { useItemsProviderContext } from '@common/react/components/Core/ItemsProvider/ItemsProvider';
import BounceLoader from '@common/react/components/UI/Loaders/BounceLoader';

interface Props {
	visible: boolean;
	textButton?: string;
	className?: string;
}

const LoadMoreButton: React.FC<Props> = ({
	visible,
	textButton = 'Load More',
	className = 'btn btn-lg btn-secondary',
}) => {
	const [loading, setLoading] = React.useState<boolean>(false);

	const context = useItemsProviderContext();

	if (!context?.state) throw new Error('Error context');

	const {
		state: { items, pagination, filters },
		actions: { loadMore },
	} = context;

	const customLoadMore = () => {
		setLoading(true);

		loadMore(filters, false, true).then(() => setLoading(false));
	};

	return visible ? (
		loading ? (
			<BounceLoader />
		) : (
			items.length < pagination.total ? (
				<button className={className} onClick={customLoadMore}>
					{textButton}
				</button>
			) : null
		)
	) : null;
};

export default LoadMoreButton;
